











import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any; // 单位是毫秒
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.time = this.data;
      //注意时间会有误差所以是每1050毫秒掉一次
      this.timeInterval = setInterval(() => {
        this.time -= 1000;
        this.countTime();
      }, 1000);
    }
  }
  private time: any = "";
  private timeInterval: any = null;
  private h1: any = " ";
  private h2: any = " ";
  private m1: any = " ";
  private m2: any = " ";
  private s1: any = " ";
  private s2: any = " ";
  private countTime() {
    let time: any = this.time;
    if (time < 1000) {
      this.$emit("update");
      this.h1 = 0;
      this.h2 = 0;
      this.m1 = 0;
      this.m2 = 0;
      this.s1 = 0;
      this.s2 = 0;
      // 离开清除定时器
      clearInterval(this.timeInterval);
      return;
    }
    //定义变量,h,m,s保存倒计时的时间
    let h, m, s;
    h = Math.floor(time / 1000 / 60 / 60);
    m = Math.floor((time / 1000 / 60) % 60);
    s = Math.floor((time / 1000) % 60);
    if (h < 10) {
      this.h1 = "0";
      this.h2 = h;
    } else {
      this.h1 = Math.floor(h / 10);
      this.h2 = h % 10;
    }
    if (m < 10) {
      this.m1 = "0";
      this.m2 = m;
    } else {
      this.m1 = Math.floor(m / 10);
      this.m2 = m % 10;
    }
    if (s < 10) {
      this.s1 = "0";
      this.s2 = s;
    } else {
      this.s1 = Math.floor(s / 10);
      this.s2 = s % 10;
    }
  }
  private mounted() {}
  private destroyed() {
    // 离开清除定时器
    clearInterval(this.timeInterval);
  }
}
